export default "__VITE_ASSET__XvokEwy3__"